import { dillardsModal } from '../modal/_dillardsModal';
import { showOrderItemShipModeSelectionDisplay } from './_showOrderItemShipModeSelectionDisplay';
import { showOrderItemStorePickupDisplay } from './_showOrderItemStorePickupDisplay';
import { showGlobalShipModeDisplay } from './_showGlobalShipModeDisplay';
import { showStorePickupTopDisplay } from './_showStorePickupTopDisplay';
import { showStorePickupHeader } from './_showStorePickupHeader';
import { nextDayModal } from './_nextDayModal';

const showTotals = (successResp) => {
	if (successResp !== undefined) {
	
		var holdNewMiniShipDiscount ='';
		if (successResp.newMiniShipDiscount !== undefined) {
			holdNewMiniShipDiscount = successResp.newMiniShipDiscount;
		}
	
	if (successResp !== undefined && successResp.newGiftWrapTotal == '$0.00' || successResp !== undefined && successResp.newGiftWrapTotal === '') {
		$('#miniGiftWrap').css('display', 'none');
		$('#miniGiftWrapValue').html(successResp.newGiftWrapTotal == null ? '' : successResp.newGiftWrapTotal);
	} else {
		if (successResp !== undefined) {
			$('#miniGiftWrap').css('display', 'block');
			$('#miniGiftWrapValue').html(successResp.newGiftWrapTotal == null ? '' : successResp.newGiftWrapTotal);
		}

	}
	if (successResp !== undefined && successResp.newAdditionalFeeTotal == '$0.00' || successResp !== undefined && successResp.newAdditionalFeeTotal === '') {
		$('#miniAdditionalFee').css('display', 'none');
		$('#miniAdditionalFeeValue').html(successResp.newAdditionalFeeTotal == null ? '' : successResp.newAdditionalFeeTotal);
		$('#miniAdditionalFeeText').html(successResp.newAdditionalFeeText == null ? '' : successResp.newAdditionalFeeText);
	} else {
		if (successResp !== undefined) {
			$('#miniAdditionalFee').css('display', 'block');
			$('#miniAdditionalFeeValue').html(successResp.newAdditionalFeeTotal == null ? '' : successResp.newAdditionalFeeTotal);
			$('#miniAdditionalFeeText').html(successResp.newAdditionalFeeText == null ? '' : successResp.newAdditionalFeeText);
		}

	}
	if (successResp !== undefined && successResp.newMiniShipDiscount == '0.00' || successResp.newMiniShipDiscount == '$0.00' || successResp !== undefined && successResp.newMiniShipDiscount === '') {
		$('#miniShippingDiscount').css('display', 'none');
		$('miniShippingDiscountValue').html(successResp.newMiniShipDiscount == null ? '' : successResp.newMiniShipDiscount);
	} else {
		if (successResp !== undefined) {
			$('#miniShippingDiscount').css('display', 'block');
			$('#miniShippingDiscountValue').html(successResp.newMiniShipDiscount == null ? '' : successResp.newMiniShipDiscount);
		}

	}

	if (successResp !== undefined) {

		$('#miniShippingValue').html(successResp.newShipping == null ? '' : successResp.newShipping);
		$('#amountNeeded').html(successResp.amountNeededFreeShip == null ? '' : successResp.amountNeededFreeShip);

		$('#miniTaxValue').html(successResp.newTax == null ? '' : successResp.newTax);
		$('#miniTotalValue').html(successResp.newOrderTotal == null ? '' : successResp.newOrderTotal);

		if (!successResp.shipModeStandard) {
			$('#freeShipAmountNeededText').css('display', 'none');
			$('#freeShipText').css('display', 'none');
		}

		if (successResp.newShipping != 'FREE') {
			$('#miniShippingValue').removeClass('text-success');
		} else {
			$('#miniShippingValue').addClass('text-success');
		}

		if (successResp.allowFreeShipping) {
			if (successResp.amountNeededFreeShip === '0.00' && successResp.newShipping != 'FREE') {
				$('#freeShipAmountNeededText').css('display', 'none');
				$('#freeShipText').css('display', 'none');
			} else if (successResp.shipModeStandard && successResp.newShipping != 'FREE') {
				$('#freeShipAmountNeededText').css('display', 'block');
			} else if (successResp.shipModeStandard && successResp.newShipping === 'FREE') {
				$('#freeShipText').css('display', 'block');
			}
		}
	}

	}


};

const showContinueButton = () => {
	$('#shippingErrorsTop').css('display', 'none');
	$('#shippingErrorsBottom').css('display', 'none');
	$('[id^=cannotShip_]').hide();

	$('.card-footer').show();
};

const hideContinueButton = () => {
	$('#shippingErrorsTop').css('display', 'block');
	$('#shippingErrorsBottom').css('display', 'block');
	$('.card-footer').hide();
};

$('#replaceHalNames').on('click', function () {
	if ($('#holdAtLocationPickupPerson').is(':visible') && $('#holdAtLocationPickupNames').is(':visible')) {
		Dillards.validateThisForm($('#holdAtLocationPickupNames'));
		$('#holdAtLocationPickupNames button').eq(0).click();
	}
	if ($('#holdAtLocationPickupNames .has-error').length > 0) {
		return false;
	} else {
		$('#updateHalName').show();
	}

	var storeName = $('#holdAtLocationStoreName').text(),
		storeAddress = $('#holdAtLocationAddress').text(),
		halCity = $('span#halCity').text(),
		halState = $('span#halState').text(),
		halZip = $('span#halZip').text(),
		locationID = $('#holdAtLocationAddress').data('locationid'),
		firstNameOverride = $('#pickupFirstNameOverride').val(),
		lastNameOverride = $('#pickupLastNameOverride').val();

	if (firstNameOverride == '') {
		$('#pickupFirstNameOverride').val($('#halFirstName').text());
		firstNameOverride = $('#halFirstName').text();
	} else {
		firstNameOverride = $('#pickupFirstNameOverride').val();
		$('#halFirstName').text(firstNameOverride + ' ');
		$('#pickupFirstNameOverride').val(firstNameOverride);
	}

	if (lastNameOverride == '') {
		$('#pickupLastNameOverride').val($('#halLastName').text());
		lastNameOverride = $('#halLastName').text();
	} else {
		lastNameOverride = $('#pickupLastNameOverride').val();
		$('#halLastName').text(lastNameOverride);
		$('#pickupLastNameOverride').val(lastNameOverride);
	}

	var addressJson = {
		firstName: firstNameOverride,
		lastName: lastNameOverride,
		pickupStoreName: storeName,
		address1: storeAddress,
		city: halCity,
		state: halState,
		zipCode: halZip,
		locationId: locationID,
	};
	$('#shippingMethodForm input[name="pickupFirstName"]').val(firstNameOverride);
	$('#shippingMethodForm input[name="pickupLastName"]').val(lastNameOverride);
	holdAtLocation(document.shippingMethodForm, addressJson);
	if ($('#holdAtLocationPickupNames .has-error').length > 0) {
		$('#holdAtLocationPickupNames').show();
		//on error don't re-populate with old name, force new name or re-enter
		$('#holdAtLocationPickupNames #pickupFirstNameOverride').val('');
		$('#holdAtLocationPickupNames #pickupLastNameOverride').val('');
	} else {
		$('#holdAtLocationPickupNames').hide();
	}
	if ($('#halFirstName').text().length >= 1 && $('#halLastName').text().length >= 1) {
		$('#holdAtLocationPickupNameDisplay').show();
	}

	$('#halOptInText').show();
	$('#shippingMethodWrapper').show();
	$('#giftWrapWrapper').show();
	$('.card-footer').show();
});

const massUpdateShippingAddress = (form, masterShippingAddressId, removeUpdateGiftWrap) => {

	$("input[name=selectPrevAddress]").each(function () {
		if ($(this).val() !== masterShippingAddressId) {
			$(this).prop('disabled', true);
		}
	});
	$('body').prepend('<div class="snackbar"><span>Updating shipping address.</span></div>');
	$("#shipping-continue").prop('disabled', true);
	$('#shippingMethodWrapper').prepend('<div class="uiblock"></div>');
	$('#giftWrapWrapper ').prepend('<div class="uiblock"></div>');
	$("#shipping-continue").attr('data-loading', '');

	$.ajax({
		url: '/webapp/wcs/stores/servlet/ShipModeUpdate?quantity_*=&isPickupItem_*=&orderItemId_*=&shipmodeId_*=&addressId_*=',
		cache: false,
		type: 'POST',
		data: 'shippingAddressId=' + masterShippingAddressId + '&orderId=' + form.orderId.value + '&massUpdate=Y&updatePrices=1' + '&removeUpdateGiftWrap=' + (removeUpdateGiftWrap ? 'Y' : ''),
		success: function (json) {
			$('.error-msg').hide();
			$('[id^=cannotShip_]').hide();
			var successResp = json.JSON;
			showTotals(successResp);
			//reset shipping methods
			var availableShippingModes = successResp.availableShippingModes == null ? '' : successResp.availableShippingModes;

			$('.standard').hide();
			$('.standard-territory').hide();
			$('.expedited').hide();
			$('.next-day').hide();
			$('.standard-notavailable').hide();
			$('.expedited-notavailable').hide();
			$('.next-day-notavailable').hide();

			if (availableShippingModes.indexOf('10001') > -1) {
				$('.standard').show();
				$('#standard-delivery').attr('checked', 'checked');
				$('#standard-delivery').prop('checked', true);
			} else if (availableShippingModes.indexOf('10004') > -1) {
				$('.standard-territory').show();
				$('#standard-territory-delivery').attr('checked', 'checked');
				$('#standard-territory-delivery').prop('checked', true);
			} else {
				$('.standard-notavailable').show();
			}

			if (availableShippingModes.indexOf('10002') > -1) {
				$('.expedited').show();
			} else {
				$('.expedited-notavailable').show();
			}

			if (availableShippingModes.indexOf('10003') > -1) {
				$('.next-day').show();
			} else {
				$('.next-day-notavailable').show();
			}

			if (availableShippingModes == '') {
				hideContinueButton();
			} else {
				showContinueButton();
			}

			displayItemsWithRestrictions(successResp.itemsCannotShip == null ? '' : successResp.itemsCannotShip);

			showGlobalShipModeDisplay(true);

			$("input[name=selectPrevAddress]").each(function () {
				$(this).prop('disabled', false);
			});
			$('.snackbar').remove();
			$("#shipping-continue").removeAttr('data-loading');
			$("#shipping-continue").prop('disabled', false);
			$('.uiblock').remove();
			return false;
		},
		error: function (json) {
			$("input[name=selectPrevAddress]").each(function () {
				$(this).prop('disabled', false);
			});
			$('.snackbar').remove();
			$("#shipping-continue").removeAttr('data-loading');
			$("#shipping-continue").prop('disabled', false);
			$('.uiblock').remove();
		},
	});
};

const allDevicesUpdateGlobalShipMode = (form, globalShippingMode) => {
	if (globalShippingMode == '10003') {
		if (form.time.value >= 12) {
			nextDayModal('nextDayAfterNoon', '10003');
		} else {
			nextDayModal('nextDayMorning', '10003');
		}
	} else if (globalShippingMode == '10002') {
		if (form.time.value >= 12) {
			nextDayModal('expeditedAfterNoon', '10002');
		} else {
			nextDayModal('expeditedMorning', '10002');
		}
	}
	$.ajax({
		url: '/webapp/wcs/stores/servlet/ShipModeUpdate?quantity_*=&isPickupItem_*=&orderItemId_*=&shipmodeId_*=&addressId_*=',
		cache: false,
		type: 'POST',
		data: 'orderId=' + form.orderId.value + '&globalShippingMode=' + globalShippingMode + '&updatePrices=1&massUpdateShipMode=Y',
		success: function (json) {
			var successResp = json.JSON;
			showTotals(successResp);
			showOrderItemShipModeSelectionDisplay(false);
			showGlobalShipModeDisplay(true);

			return false;
		},
	});
};

const storeCurbside = (form, returnedStoreInfo) => {
	var data = $(form).serialize();
	var storeParms = '';
	for (var prop in returnedStoreInfo) {
		if (storeParms != '' && prop != 'days') {
			storeParms = storeParms + '&';
			storeParms = storeParms + prop + '=' + encodeURIComponent(returnedStoreInfo[prop]);
		} else if (storeParms == '') {
			storeParms = storeParms + prop + '=' + encodeURIComponent(returnedStoreInfo[prop]);
		}
	}
	$('#storeCurbsideStates').on('change', function () {
		$('#curbsideOptInText').hide();
	});
	$.ajax({
		url: '/webapp/wcs/stores/servlet/StoreCurbside?' + storeParms,
		cache: false,
		type: 'POST',
		data: data,
		success: function (json) {
			var successResp = json.JSON;
			showTotals(successResp);
			var changedShipAddressMap = successResp.changedShipAddressMap == null ? '' : successResp.changedShipAddressMap;
			//change column headings
			showStorePickupHeader(false);

			var itemsCannotShip = successResp.itemsCannotShip == null ? '' : successResp.itemsCannotShip;
			displayItemsWithRestrictions(itemsCannotShip);

			if (itemsCannotShip.length > 0) {
				hideContinueButton();
				$('#curbsideOptInText').hide();
			} else {
				showContinueButton();
				$('#giftWrapWrapper').show();
				$('#curbsideOptInText').show();
			}

			//            showContinueButton();
			//remove gift wrap box selections, gift wrap costs, gift wrap text
			//$('.giftbox-wrapper').find('textarea[id^=orderItemGiftMsgTxt]').attr("disabled", "disabled");
			//$('.giftbox-wrapper').children('.giftbox-message-wrapper').removeClass('active');
			//$('input[name$=giftWrapCheckBox]').prop('checked', '');
			//$(".totalGiftWrapCharge").html(successResp.newGiftWrapTotal == null ? "" : successResp.newGiftWrapTotal);
			//$('.totalGiftWrap').css("display", "block");
			//if (successResp.newGiftWrapTotal == "$0.00" || successResp.newGiftWrapTotal === "") $('.totalGiftWrap').css("display", "none");

			//reset registry and previously used select boxes
			$('.shipping-select option').each(function () {
				$('[class^=SelectAddress_]').removeProp('selected');
			});
			$('.registry-select option').each(function () {
				$('[class^=SelectRegistryAddress_]').removeProp('selected');
			});
			if (navigator.userAgent.match(/iphone|ipad/i)) {
				$('.shipping-select option:first').prop('selected', 'selected');
				$('.registry-select option:first').prop('selected', 'selected');
			} else {
				$('.shipping-select option:first').prop('selected', 'selected');
				$('.shipping-select option:first').attr('selected', 'selected');
				$('.registry-select option:first').prop('selected', 'selected');
				$('.registry-select option:first').attr('selected', 'selected');
			}

			$('input[name=curbsideSelected]').val('true');

			return false;
		},
	});
};

const storePickup = (form, returnedStoreInfo) => {
	var data = $(form).serialize();
	var storeParms = '';
	for (var prop in returnedStoreInfo) {
		if (storeParms != '' && prop != 'days') {
			storeParms = storeParms + '&';
			storeParms = storeParms + prop + '=' + encodeURIComponent(returnedStoreInfo[prop]);
		} else if (storeParms == '') {
			storeParms = storeParms + prop + '=' + encodeURIComponent(returnedStoreInfo[prop]);
		}
	}
	$('#storePickUpStates').on('change', function () {
		$('#optInText').hide();
	});
	$.ajax({
		url: '/webapp/wcs/stores/servlet/StorePickUp?' + storeParms,
		cache: false,
		type: 'POST',
		data: data,
		success: function (json) {
			var successResp = json.JSON;
			showTotals(successResp);
			var changedShipAddressMap = successResp.changedShipAddressMap == null ? '' : successResp.changedShipAddressMap;
			//change column headings
			showStorePickupHeader(true);

			var itemsCannotShip = successResp.itemsCannotShip == null ? '' : successResp.itemsCannotShip;
			displayItemsWithRestrictions(itemsCannotShip);

			if (itemsCannotShip.length > 0) {
				hideContinueButton();
				$('#optInText').hide();
			} else {
				showContinueButton();
				$('#giftWrapWrapper').show();
				$('#optInText').show();
			}

			//reset registry and previously used select boxes
			$('.shipping-select option').each(function () {
				$('[class^=SelectAddress_]').removeProp('selected');
			});
			$('.registry-select option').each(function () {
				$('[class^=SelectRegistryAddress_]').removeProp('selected');
			});
			if (navigator.userAgent.match(/iphone|ipad/i)) {
				$('.shipping-select option:first').prop('selected', 'selected');
				$('.registry-select option:first').prop('selected', 'selected');
			} else {
				$('.shipping-select option:first').prop('selected', 'selected');
				$('.shipping-select option:first').attr('selected', 'selected');
				$('.registry-select option:first').prop('selected', 'selected');
				$('.registry-select option:first').attr('selected', 'selected');
			}

			$('input[name=pickupSelected]').val('true');			
			return false;
		},
	});
};

const holdAtLocation = (form, locationInfo) => {
	var data = $(form).serialize();
	for (var prop in locationInfo) {
		if (prop != 'hours' && prop != 'coords') {
			data = data + '&' + prop + '=' + locationInfo[prop];
		}
	}

	$.ajax({
		url: '/webapp/wcs/stores/servlet/HoldAtLocation',
		cache: false,
		type: 'POST',
		data: data,
		success: function (json) {
			var successResp = json.JSON;
			showTotals(successResp);

			$('li#holdAtLocationStoreName').text(successResp.address.pickupStoreName);
			$('li#holdAtLocationAddress').text(successResp.address.address1);
			$('li#holdAtLocationCityStateZip span#halCity').text(successResp.address.city);
			$('li#holdAtLocationCityStateZip span#halState').text(successResp.address.state);
			$('li#holdAtLocationCityStateZip span#halZip').text(successResp.address.zipCode);
			$('#address-checkout-hal').data('json', successResp.address);
			$('#holdAtLocationAddress').data('locationid', successResp.address.locationId);
			$('#holdAtLocationInputs').hide();
			$('#address-checkout-hal').show();
			$('#changeHalLocation, #updateHalName').show();

			var availableShippingModes = successResp.availableShippingModes == null ? '' : successResp.availableShippingModes;

			$('.standard').hide();
			$('.standard-territory').hide();
			$('.expedited').hide();
			$('.next-day').hide();
			$('.standard-notavailable').hide();
			$('.expedited-notavailable').hide();
			$('.next-day-notavailable').hide();

			if (availableShippingModes.indexOf('10001') > -1) {
				$('.standard').show();
				$('#standard-delivery').attr('checked', 'checked');
				$('#standard-delivery').prop('checked', true);
			} else if (availableShippingModes.indexOf('10004') > -1) {
				$('.standard-territory').show();
				$('#standard-territory-delivery').attr('checked', 'checked');
				$('#standard-territory-delivery').prop('checked', true);
			} else {
				$('.standard-notavailable').show();
			}

			if (availableShippingModes.indexOf('10002') > -1) {
				$('.expedited').show();
			} else {
				$('.expedited-notavailable').show();
			}

			if (availableShippingModes.indexOf('10003') > -1) {
				$('.next-day').show();
			} else {
				$('.next-day-notavailable').show();
			}

			var itemsCannotShip = successResp.itemsCannotShip == null ? '' : successResp.itemsCannotShip;
			displayItemsWithRestrictions(itemsCannotShip);

			if (availableShippingModes == '' || itemsCannotShip.length > 0) {
				hideContinueButton();
				$('#giftWrapWrapper').hide();
				$('#halOptInText').hide();
				$('#hal-phone').val('');
			} else {
				showContinueButton();
				$('#giftWrapWrapper').show();
				$('#halOptInText').show();
			}

			showGlobalShipModeDisplay(true);

			return false;
		},
	});
};

const displayItemsWithRestrictions = (itemsCannotShip) => {
	if ($('.item-cannot-ship').length > 0) $('.item-cannot-ship').remove();

	if (itemsCannotShip.length > 0) {
		if ($('#shippingErrorsTop').length > 0) $('#shippingErrorsTop').css('display', 'block');

		$.each(itemsCannotShip, function (key, value) {
			var itemImg = $("#giftWrapperBody .list-reset [value='" + value + "']")
				.parent('.list-item')
				.find('.item-image-wrapper')
				.html();
			var itemDesc = $("#giftWrapperBody .list-reset [value='" + value + "']")
				.parent('.list-item')
				.find('.item-desc-li .desc')
				.html();
			var itemData = $("#giftWrapperBody .list-reset [value='" + value + "']")
				.parent('.list-item')
				.find('.item-desc-li .data')
				.html();
			$('#checkout-content-column #shippingErrorsTop').after(`
					<div class="item-cannot-ship" data-val="${value}">
			<div class="message-top"><p>This item cannot be shipped to the selected address.</p></div>
			<ul class="list-reset list-item">
			<li>${itemImg}</li>
			<li><h5>${itemDesc}</h5>${itemData}</li>
			</ul>
			<div class="message-bottom"><p>Please select different address or remove the item from cart to proceed.</p></div>
			</div>`);
		});

		$('html, body').animate(
			{
				easing: 'linear',
				scrollTop: $('#page-wrapper').offset().top,
			},
			0
		);
	}
};

export { storePickup, storeCurbside, holdAtLocation, massUpdateShippingAddress, showTotals, allDevicesUpdateGlobalShipMode, displayItemsWithRestrictions };
